if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){    
    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));



    $('.sym-slides').slick({
        accessibility: false
    });



})();

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('#header');
    const isMenuVisible = menu && menu.classList.contains('open-menu');
    const elements = document.querySelectorAll('.privary-navigation__item a, .secondary-navigation__item a, .menu__container-bottom .phone');

    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    const burgerMenu = document.querySelector('.menu-burger');
    const burgerMenuInput = document.getElementById('burger');
    if (burgerMenu) {
        burgerMenu.addEventListener('click', () => {
            updateMenuTabIndex();
        });

        burgerMenu.addEventListener('keydown', function(event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.click();
            }
        });
    }
    const menu = document.querySelector('#header');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }

    if (burgerMenuInput) {
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && burgerMenuInput.checked) {
                burgerMenuInput.checked = false;
                updateMenuTabIndex();
            }
        });
    }
});

/** Keyboard Accessibility: Close Menu with Enter, and Escape Keys **/

$(".booking__close, .booking__close-1").on("keydown", function(event) {
    if (event.key === "Enter") {
        $(this).click();
    }
});

document.addEventListener('keydown', (event) => {
    const bookingContainer1 = document.querySelector('.booking__container');
    const bookingContainer2 = document.querySelector('.booking__container-1');

    const closeBooking = (bookingContainer) => {
        if (event.key === 'Escape' && bookingContainer && bookingContainer.classList.contains('open-booking-container')) {
            bookingContainer.classList.add('close-booking-container');
            bookingContainer.classList.remove('open-booking-container');
        }
    };
    closeBooking(bookingContainer1);
    closeBooking(bookingContainer2);
});